import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export const TilesGridLoadingCell = ({
  onLoading, containerClass, children,
}) => {
  const gridCellContent = useRef(null);
  const [hasSetUpObserver, setHasSetUpObserver] = useState(false);
  const onLoadingCalled = useRef(false);

  const observer = useMemo(() => {
    onLoadingCalled.current = false;
    if (window.IntersectionObserver && onLoading) {
      return new IntersectionObserver((entries) => {
        const [entry] = entries || [];

        if (entry && entry.isIntersecting && onLoading && !onLoadingCalled.current) {
          onLoading();
          onLoadingCalled.current = true;

          if (entry && entry.target) {
            observer.unobserve(entry.target);
          }
        }
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.0,
      });
    }
    return null;
  }, [onLoading]);

  useEffect(() => {
    if (observer && gridCellContent.current && !hasSetUpObserver) {
      observer.observe(gridCellContent.current);
      setHasSetUpObserver(true);
    }
  }, [observer, gridCellContent, hasSetUpObserver]);

  return (
    <div ref={gridCellContent} className={containerClass}>
      {children}
    </div>
  );
};

TilesGridLoadingCell.propTypes = {
  onLoading: PropTypes.func,
  children: PropTypes.node,
  containerClass: PropTypes.string,
};

TilesGridLoadingCell.defaultProps = {
  onLoading: null,
  children: null,
  containerClass: undefined,
};
